<div class="db-activity-notifications" [ngClass]="{'db-activity-notifications_toggled': toggled$ | async, 'db-page-with-banner-margin-small': hasHostingBanner}" (click)="stopEvent($event)">
  <div class="db-activity-notifications__header">
    <h3>Notifications</h3>
    <a (click)="toggle()"><i class="db-icon db-icon-hide-notification"></i></a>
  </div>

  <div class="db-activity-notifications__body">
    <div dbCustomScrollbar class="db-activity-notifications__items" *ngIf="!(activityNotificatonsLoading$ | async) && activityNotificatonsArray && activityNotificatonsArray.length">
      <db-activity-notification [activityNotification]="activityNotification" *ngFor="let activityNotification of activityNotificatonsArray"></db-activity-notification>
    </div>

    <div class="db-activity-notifications__no-items-message" *ngIf="!(activityNotificatonsLoading$ | async) && !activityNotificatonsArray?.length">
      <div>
        <div></div>
        <div>Hi!</div>
        <div>You don't have notifications. New notifications will appear here</div>
      </div>
    </div>

    <db-loading-screen *ngIf="(activityNotificatonsLoading$ | async)"></db-loading-screen>
  </div>
</div>
